import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { QuickCaptureDrawerComponent } from './quick-capture-drawer/quick-capture-drawer.component';

@NgModule({
  imports: [SharedModule],
  declarations: [QuickCaptureDrawerComponent],
})
export class QuickCaptureModule {}
